import { CasinoBannersDataState } from 'src/AppState/CmsState/CasinoBannersDataState/CasinoBannersData.state';
import { CasinoBannerType } from 'src/domains/casino/models/models';
interface PropsType {
    banner: CasinoBannerType;
    casinoBannersState: CasinoBannersDataState;
}

export class SingleBannerState {
    public constructor(private readonly props: PropsType) {}

    public editBanner = async (): Promise<void> => {
        this.props.casinoBannersState.setEditMode(true);
        await this.props.casinoBannersState.setEditBanner(this.props.banner);
    };

    public deleteBanner = async (): Promise<void> => {
        await this.props.casinoBannersState.deleteBanner(this.props.banner.id);
    };

    public setPublished = async (): Promise<void> => {
        await this.props.casinoBannersState.setBannerPublished(this.props.banner.id);
    };

    public moveUp = async (): Promise<void> => {
        await this.props.casinoBannersState.moveBanner(this.props.banner.id, 'up');
    };

    public moveDown = async (): Promise<void> => {
        await this.props.casinoBannersState.moveBanner(this.props.banner.id, 'down');
    };
}
